// ProtectedClientRoute.jsx
// Wrap the gallery/clients/profile/intro routes with this so only logged-in clients see them.
// Usage in Routes.jsx:
//   <Route path="/gallery" element={<ProtectedClientRoute><GalleryPage /></ProtectedClientRoute>} />

import React from "react";
import { Navigate } from "react-router-dom";
import { isClientLoggedIn } from "./clientApi";

export default function ProtectedClientRoute({ children }) {
  if (!isClientLoggedIn()) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
